import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Form,
  Input,
  Button,
  Tooltip,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useFormik } from "formik";
import "react-toastify/dist/ReactToastify.css";

import { useToast } from "../../Components/Common/ToastContext";
import { updateSettingsKey, viewSettingsKey } from "./_requests";
import BreadCrumb from "../../Components/Common/BreadCrumb";

type TooltipFields = {
  send_grid_key: boolean;
  sms_gateway_key: boolean;
  sms_gateway_sender: boolean;
  sms_gateway_content: boolean;
  sms_gateway_template_id: boolean;
  abstract_email_api_key: boolean;
};

const EditSMSSettingsKey = () => {
  document.title = "Paal Dappa | Admin panel";

const tooltipIconStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '15px',
  height: '15px',
  borderRadius: '50%',
  backgroundColor: 'hsla(0, 100%, 99%, 1.00)',
  color: 'black',
  fontSize: '12px',
  cursor: 'pointer',
  marginLeft: '8px',
  border: '1px solid black'
};


  const { id } = useParams();
  const { showToast } = useToast();
  const history = useNavigate();
  const [SettingsKey, setSettingsKey] = useState<any>({});
  const [tooltipOpen, setTooltipOpen] = useState<TooltipFields>({
    send_grid_key: false,
    sms_gateway_key: false,
    sms_gateway_sender: false,
    sms_gateway_content: false,
    sms_gateway_template_id: false,
    abstract_email_api_key: false,
  });

  const toggleTooltip = (field: keyof TooltipFields) => {
    setTooltipOpen(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  useEffect(() => {
    viewSettingsKey(id).then((res: any) => {
      setSettingsKey(res);
    });
  }, [id]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      send_grid_key: SettingsKey.send_grid_key || "",
      abstract_email_api_key: SettingsKey.abstract_email_api_key || "",
      update_type: 1
    },
    onSubmit: async (values) => {
      try {
        const res: any = await updateSettingsKey(id, values);
        if (res.status === true || res.data?.status === true) {
          toast.success(res.message || "Email settings updated successfully", { autoClose: 3000 });
          history("/settings", { state: { activeTab: "4" } });
        } else {
          toast.error(res.message || "Failed to update email settings", { autoClose: 3000 });
        }
      } catch (error: any) {
        toast.error(error.message || "An error occurred", { autoClose: 3000 });
      }
    },
  });

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} limit={1} />
      <Container fluid>
        <BreadCrumb title="Edit Email Settings" pageTitle="Paal Dappa" />
        <Row>
          <Col md={12}>
            <Card>
              <CardBody>
                <br />
                <br />
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                  }}
                >
                  {/* Email Settings */}
                  <Row className="mb-3">
                    <Col md={5}>
                      <Label className="fw-bold">SendGrid API Key</Label>
                      <span id="sendGridTooltip" style={tooltipIconStyle}>
                        !
                      </span>
                      <Tooltip
                        placement="right"
                        isOpen={tooltipOpen.send_grid_key}
                        target="sendGridTooltip"
                        toggle={() => toggleTooltip("send_grid_key")}
                      >
                        Example: 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
                      </Tooltip>
                    </Col>
                    <Col md={7}>
                      <Input
                        type="text"
                        name="send_grid_key"
                        value={validation.values.send_grid_key}
                        onChange={validation.handleChange}
                        placeholder="Enter SendGrid API Key"
                      />
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={5}>
                      <Label className="fw-bold">Abstract Email API Key</Label>
                      <span id="abstractEmailTooltip" style={tooltipIconStyle}>
                        !
                      </span>
                      <Tooltip
                        placement="right"
                        isOpen={tooltipOpen.abstract_email_api_key}
                        target="abstractEmailTooltip"
                        toggle={() => toggleTooltip("abstract_email_api_key")}
                      >
                        Example: fcae80f584984aa1ae39f660de5245b7
                      </Tooltip>
                    </Col>
                    <Col md={7}>
                      <Input
                        type="text"
                        name="abstract_email_api_key"
                        value={validation.values.abstract_email_api_key}
                        onChange={validation.handleChange}
                        placeholder="Enter Abstract Email API Key"
                      />
                    </Col>
                  </Row>
                  <div className="text-end">
                    <Button type="submit" color="success" className="me-3 w-sm">
                      Submit
                    </Button>

                    <Button type="button" color="secondary" className="w-sm" onClick={() => history("/settings")}>
                      Cancel
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EditSMSSettingsKey;